// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3tOhj","footer":"ModalUpdate_footer__1sAAZ"};